
/** @format */

import React, { useState, useRef } from 'react';
import { PageContainer, FilterPod, TableComponents, ExportButton } from 'components';
import { toFilterVOS } from 'components/FilterPod';
import { useStyles } from './style';
import { Grid, Button, Box } from '@mui/material';
import { enifyDateTime } from 'utility';
import { useExportFile } from 'hooks';
import DiscountCodesServices from './services/IncomeByProductServices';
import { columns, generateData } from './components/Columns';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';
import {getExportServiceProviderProductUrl} from 'URLs';
const AssignedDelegation = () => {
  // -- STATES --//
  const tableRef = useRef();
  const actionsList =
    getDynamicObjectAction([
      'productsReportFinancialPage',
      'exportProductsReportFinancialPage'

    ])
  const { loading, setLoading, filters, setFilters, filterParams, setFilterParams, size, setSize, page, setPage, } =
    useCustomHook();
  // --HOOKS--//
  const classes = useStyles();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const { downloadFile, isExporting } = useExportFile({
    url: getExportServiceProviderProductUrl(),
    filename: 'income-report-by-products',
  });
  const currencyText = useCurrencyUnit(false);

  // --API REQUESTS--//
  const getDicsountCodes = async (query) => {
    try {
      setLoading(true);

      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.field) {
        case 'id':
          orderByName = 'شناسه محصول';
          break;
        case 'name':
          orderByName = 'نام محصول';
          break;
        case 'count':
          orderByName = 'مجموع تعداد فروش';
          break;
        case 'income':
          orderByName = 'مجموع مبلغ فروش';
          break;
        default:
          break;
      }
      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);
      // let queries = filterVOStoQueryStr(filter);

      const params = {
        page: query ? query?.pageNumber : page,
        size: query ? query?.pageSize : size,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')),
        // ...queries
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await DiscountCodesServices.getIncome(data, params);

      let list = [];
      if (res.result) {
        list = generateData(res.result?.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query ? query?.pageSize : page,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.result?.totalCount,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const hint = 'در این بخش می‌توانید گزارش درآمد تجمیعی کسب‌وکار را به تفکیک محصولات مشاهده کنید.';

  return (
    <PageContainer
      title="گزارش درآمد بر اساس محصولات"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.INCOME_BY_PRODUCTS}
      className={classes.root}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['productsReportFinancialPage'] && (
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          )}
          {actionsList['exportProductsReportFinancialPage'] && (
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        {actionsList['productsReportFinancialPage'] && (
          <Box>
            <FilterPod
              filters={filters}
              onChange={onFiltersChange}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}
      </Grid>
      {(actionsList['productsReportFinancialPage'] && currencyText) && (
        <TableComponents
          data={getDicsountCodes}
          columns={columns(currencyText)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getDicsountCodes(ps)
          }}
        />
      )}
    </PageContainer>
  );
};


export default AssignedDelegation;
